import { render } from "./ExchangeOffice.vue?vue&type=template&id=4cc9c7a4"
import script from "./ExchangeOffice.vue?vue&type=script&lang=js"
export * from "./ExchangeOffice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/auctions/ExchangeOffice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cc9c7a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cc9c7a4', __exports__)) {
    api.reload('4cc9c7a4', __exports__)
  }
  
  module.hot.accept("./ExchangeOffice.vue?vue&type=template&id=4cc9c7a4", () => {
    api.rerender('4cc9c7a4', render)
  })

}


export default __exports__